<template>
    <div class="waba-supsis-partner-remove">
        <div class="title">Whatsapp Business API V2 partner kaldırıldı</div>
        <div class="meta">
            <div><b>Event</b>: {{ $_.get(activity, "payload.event") }}</div>
            <div><b>Kanal ID</b>: {{ $_.get(activity, "payload.channelId") }}</div>
            <div><b>WABA ID</b>: {{ $_.get(activity, "payload.waba_info.waba_id") }}</div>
            <div><b>Owner Business ID</b>: {{ $_.get(activity, "payload.waba_info.owner_business_id") }}</div>
        </div>
        <details class="raw">
            <summary>Ham payload</summary>
            <pre>{{ prettyPayload }}</pre>
        </details>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "WabaSupsisPartnerRemove",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        prettyPayload() {
            try {
                return JSON.stringify(this.$_.get(this.activity, "payload", {}), null, 2);
            } catch (e) {
                return String(this.$_.get(this.activity, "payload", ""));
            }
        },
    },
});
</script>

<style scoped lang="scss">
.waba-supsis-partner-remove {
    .title {
        font-weight: 600;
        margin-bottom: 6px;
    }
    .meta {
        display: flex;
        flex-direction: column;
        gap: 2px;
        margin-bottom: 8px;
    }
    .raw {
        pre {
            max-height: 240px;
            overflow: auto;
            padding: 10px;
            border: 1px solid var(--color-border-default);
            border-radius: 6px;
            background: var(--color-bg-neutral-default);
        }
        summary {
            cursor: pointer;
            user-select: none;
            margin-bottom: 6px;
        }
    }
}
</style>
